"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKGeoThumbnailSVG = void 0;
var react_1 = __importDefault(require("react"));
var react_inlinesvg_1 = __importDefault(require("react-inlinesvg"));
require("./GKGeoThumbnailSVG.css");
var GKGeoThumbnailSVG = function (_a) {
    var base64Svg = _a.base64Svg, id = _a.id;
    var decodeUrlSafeBase64 = function (data) {
        return atob(data.replace(/_/g, "/").replace(/-/g, "+"));
    };
    return (react_1.default.createElement("div", { className: "gk-geo-thumbnail" // this matches <GKGeoThumbnail />
        , "data-qa": "gk-geo-thumbnail", id: id, role: "img" },
        react_1.default.createElement(react_inlinesvg_1.default, { src: decodeUrlSafeBase64(base64Svg), style: { width: "32px", height: "32px" } })));
};
exports.GKGeoThumbnailSVG = GKGeoThumbnailSVG;
